import React from "react";
import "../../css/ServicesGrid.css";

export default function ServicesGrid({ items = [] }) {
  return (
    <section className="services-grid-1">
      {items.map((item, index) => {
        const isEven = index % 2 === 0;

        return (
          <div
            key={index}
            className={`sg-row ${!isEven ? "sg-row-reverse" : ""}`}
          >
            <div
              className={`sg-card sg-card-primary 
                ${
                isEven ? "sg-card-primary" : "sg-card-secondary"
                }
              `}
            >
              <h2>{item.title}</h2>
              <div className="sg-desc">
                {item.description.map((para, i) => (
                  <p
                    key={i}
                    className={i % 2 !== 0 ? "sg-para-accent" : "sg-para-light"}
                  >
                    {para}
                  </p>
                ))}
              </div>
            </div>

            <div className="sg-imageWrap">
              <img
                src={item.image}
                alt={item.imageAlt || item.title}
                className="sg-image"
              />
            </div>
          </div>
        );
      })}
    </section>
  );
}
